
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casestudy/coco-cart",
      function () {
        return require("private-next-pages/casestudy/coco-cart.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casestudy/coco-cart"])
      });
    }
  